import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M10.5 11.75a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75V12.5a.75.75 0 0 1-.75-.75M12 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
    <path
      fillRule="evenodd"
      d="M12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25M2.75 12a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0"
      clipRule="evenodd"
    />
  </>
);

const Info = Icon('info', svgContents);

export default Info;
